import styled from "styled-components";

const Panel = styled.div`
  background-color: #f7f8f9;
  border: 1px solid #e1e5e9;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
`;

export default Panel;
